import React, { Fragment } from "react";
import { Card, Col } from 'react-bootstrap';
import '../../../../styles/diario.scss'

const Diaria = (props) => {


    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                <Card.Header><h5>Índice {props.diaria.indice} para o cargo {props.diaria.cargo}</h5></Card.Header>
                    <Card.Body>
                        <p>Distância: {props.diaria.distancia}</p>
                        <p>Valor: {props.diaria.valor}</p>
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Diaria;